export default __webpack_public_path__ + "static/media/widow-sweeper-mini.35c1e010.png";